// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M26.344 48.617c0 .446.082.867.246 1.266.164.375.41.726.738 1.054l27.879 27.247c.633.632 1.395.949 2.285.949.61 0 1.149-.14 1.617-.422a3.063 3.063 0 0 0 1.16-1.16c.305-.469.458-1.008.458-1.617 0-.868-.317-1.63-.95-2.286l-25.593-25.03 25.593-25.032c.633-.656.95-1.418.95-2.285 0-.61-.153-1.149-.457-1.617a3.064 3.064 0 0 0-1.16-1.16c-.47-.282-1.008-.422-1.618-.422-.89 0-1.652.304-2.285.914l-27.879 27.28a3.328 3.328 0 0 0-.738 1.09 3.038 3.038 0 0 0-.246 1.231Z"
			fill="#000"
		/>
	</svg>
);
export default ChevronLeft;
